import { ContentfulIcon } from '@/components/icon';
import { Text } from '@/components/text';

import type { PlanSchema } from '@energy-retailer/schema';

type ProductPlanTitleProps = Pick<PlanSchema, 'product'>;

const ProductPlanCardTitle = ({ product }: ProductPlanTitleProps) => {
  const { name, tagline, icon } = product;

  return (
    <div className="flex items-center gap-b">
      <ContentfulIcon
        id={icon}
        className="h-icon-md w-icon-md rounded-rad-a bg-gray-50 p-a text-product-plan-card-accent lg:h-icon-lg lg:w-icon-lg"
      />
      <div>
        <Text
          variant="h3"
          as="h3"
          className="text-product-plan-card-accent"
        >
          {name}
        </Text>
        {tagline ? <Text variant="body2">{tagline}</Text> : null}
      </div>
    </div>
  );
};

export { ProductPlanCardTitle };
